import { callUtilFunctionInSandBoxedIframe } from '@features/FileRenderer/callUtilFunctionInSandBoxedIframe';

export interface IExcelSheet {
    rows: (string | number)[][];
}

export interface IExcelFile {
    sheets: Record<string, IExcelSheet>;
}

export async function parseExcelInIframe(arrayBuffer: ArrayBuffer): Promise<IExcelFile> {
    return callUtilFunctionInSandBoxedIframe('parseExcelArrayBuffer', [arrayBuffer]);
}
